import * as React from 'react'
import * as st from './contactUsBox.module.scss'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Text, Button } from 'DVWebNodeUI'

export interface IContactUsBoxProps {
  header?: WpsRuntime.atv.wps.DVString,
  body?: WpsRuntime.atv.wps.DVString,
  footer?: WpsRuntime.atv.wps.DVString,
  buttonText?: WpsRuntime.atv.wps.DVString,
  buttonLink?: string,
  contactBoxType?: WpsRuntime.atv.wps.ContactBoxType
}

const typeToIcon = {
  Chat: st.iconChat,
  CallMe: st.iconPhone,
}

export const ContactUsBoxComp = ({ header, body, footer, buttonText, buttonLink, contactBoxType }: IContactUsBoxProps) => {
  const iconClass = contactBoxType ? typeToIcon[contactBoxType] : undefined

  return buttonLink ? (
    <div className={st.box}>
      <div className={st.row}>
        <div className={`${st.col} ${st.boxHeader}`}>
            <span className={st.textSizeMedium}>
              <Text string={header} />
            </span>
        </div>
      </div>
      <div className={st.row}>
        <div className={`${st.col} ${st.boxBody}`}>
          <Text string={body}/>
        </div>
      </div>
      <div className={st.row}>
        <div className={`${st.col} ${st.boxFooter}`}>
          <strong><Text string={footer}/></strong>
        </div>
      </div>
      <div className={st.row}>
        <div className={`${st.col} ${st.buttonWrapper}`}>
          <Button className={st.buttonClass} href={buttonLink}>
            <div className={`${st.col} ${st.icon}`}>
              {iconClass ? <div className={iconClass}/> : null}
            </div>
            <Text tag="div" string={buttonText}/></Button>
        </div>
      </div>
    </div>
  ) : null
}

export const ContactUsBox = ContactUsBoxComp
